import { useCallback, useEffect, useState } from "react";

import { get, isEmpty, size } from "lodash";

import Loader from "./loader";
import { ICONS } from "../../constants/icons.constants";
import { fetchSongsAccrodingToReaction } from "../../actions/songs.actions";
import NillDisplaySchedule from "../../components/nillDisplaySchedule/NillDisplaySchedule";
import Table from "../../components/table/Table";
import { columns } from "../../config/likepage.config";

import styles from "./likedPage.module.scss";
import userStore from "../../zustand/user.store";
import imageStore from "../../zustand/image.store";
import { downloadSongImage } from "../../helpers/generel.helpers";

const LikedPage = () => {
  // const { songs: favoriteSongs } = favoriteSongStore((state) => ({
  //   songs: state.songs,
  // }));
  const { userOffline } = userStore((state) => ({
    userOffline: state.userOffline,
  }));
  const { addImage } = imageStore((state) => ({
    addImage: state.addImage,
  }));

  const [isLoading, setIsLoading] = useState(false);
  const [songs, setSongs] = useState([]);

  useEffect(() => {
    // if (isEmpty(favoriteSongs)) return;
    (async () => {
      setIsLoading(true);
      const songs = await fetchSongsAccrodingToReaction("LIKE", userOffline);

      setSongs(songs);
      setIsLoading(false);
    })();
  }, [userOffline]);

  const downloadSongImages = useCallback(async () => {
    for (let index = 0; index < size(songs); index++) {
      if (index >= size(songs)) return;
      const imageToDownload = get(songs, `${index}.imageFileName`, "");

      try {
        const result = await downloadSongImage(imageToDownload);
        if (result) {
          addImage(imageToDownload);
        }
      } catch (error) {
        //
      }
    }
  }, [songs, addImage]);

  useEffect(() => {
    downloadSongImages();
  }, [downloadSongImages]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>Liked Songs</div>
      <div className={styles.second}>
        {isLoading ? (
          <Loader />
        ) : isEmpty(songs) ? (
          <NillDisplaySchedule
            head="You don't have any liked songs"
            btnPlaceholder="Create Playlist"
            iconType={ICONS.MY_PLAYLIST}
            hideButton
          />
        ) : (
          <Table rows={songs} columns={columns} />
        )}
      </div>
    </div>
  );
};

export default LikedPage;
